import { combineReducers } from 'redux'
import * as actions from "../actions";
import {ActionType, getType} from "typesafe-actions";
import {WorksData, CountriesProps, EducationData, CommonImages, CommonPhone, BannerData} from "../../pages/types";
import {getUserStorage, saveUserStorage, UserStorage} from "../../units";
import {Subtitles} from "../actions";


export type State = {
    readonly works:Array<WorksData>;
    readonly countries:Array<CountriesProps>;
    readonly educations:Array<EducationData>;
    readonly userInfo:UserStorage | null;
    readonly commonImages:CommonImages | null;
    readonly commonPhones:Array<CommonPhone>;
    readonly banners:Array<Array<BannerData>>;
    readonly ads:boolean;
    readonly subtitles: Subtitles;
    readonly skill: string;
}

const initialState:State = {
    works:[],
    countries:[],
    educations:[],
    userInfo:getUserStorage(),
    commonImages:null,
    commonPhones:[],
    banners:[],
    ads:true,
    subtitles:[],
    skill:''
}


export type Action = ActionType<typeof actions>

export default combineReducers<State,Action>({
    works : (state = initialState.works, action) => {
        switch (action.type) {
            case getType(actions.worksAction):
                return [...action.payload];
            default:
                return state
        }
    },
    countries : (state = initialState.countries, action) => {
        switch (action.type) {
            case getType(actions.countriesAction):
                return [...action.payload];
            default:
                return state
        }
    },
    educations : (state = initialState.educations, action) => {
        switch (action.type) {
            case getType(actions.educationAction):
                return [...action.payload];
            default:
                return state
        }
    },
    banners:(state = initialState.banners, action) => {
        // console.log(state,action)
        switch (action.type) {
            case getType(actions.bannerAction):
                state[action.payload.active] = action.payload.data
                return [...state]
            default:
                return state
        }
    },
    userInfo:(state = initialState.userInfo, action) => {
        switch (action.type) {
            case getType(actions.userInfoAction):
                // console.log(state,action)
                if(action.payload === null){
                    return null
                }else{
                    const res = Object.assign({},state,action.payload)
                    saveUserStorage(res)
                    return res
                }
            default:
                return state
        }
    },
    commonImages:(state = initialState.commonImages, action) => {
        switch (action.type) {
            case getType(actions.commonImagesAction):
                return Object.assign({},state,action.payload)
            default:
                return state
        }
    },
    commonPhones:(state = initialState.commonPhones, action) => {
        switch (action.type) {
            case getType(actions.commonPhones):
                return [...action.payload];
            default:
                return state
        }
    },
    subtitles:(state = initialState.subtitles, action) => {
        switch (action.type) {
            case getType(actions.subtitlesAction):
                return [...action.payload];
            default:
                return state
        }
    },
    ads:(state = initialState.ads, action) => {
        switch (action.type) {
            case getType(actions.adsActive):
                return action.payload;
            default:
                return state
        }
    },
    skill:(state= initialState.skill,action) => {
        switch (action.type) {
            case getType(actions.userSkill):
                return action.payload;
            default:
                return state
        }
    }
})
